<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputMobile" });
import InputMobileNumber from "./components/InputMobileNumber.svelte";
import SelectMobileCountryCode from "./components/SelectMobileCountryCode.svelte";
export let value = {};
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = false;
const MOBILE = { countryCode: void 0, number: void 0, ...value };
const onMobileChange = ({ number, countryCode }) => {
    value = countryCode !== void 0 && number !== void 0 ? { countryCode, number } : {};
};
$: onMobileChange(MOBILE);
</script>

<fieldset class = 's8-input-mobile'>
    <SelectMobileCountryCode
        bind:key = { MOBILE.countryCode }
        { isDisabled }
        { isRequired }
    />
    <InputMobileNumber
        bind:value = { MOBILE.number }
        { isDisabled }
        { isReadonly }
        { isRequired }
    />
</fieldset>

<style>
    fieldset.s8-input-mobile {
        display: flex;
        -moz-column-gap: 20px;
             column-gap: 20px;
    }</style>